import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import TicketForm from "./TicketForm";
import TicketDownload from "./TicketDownload";

//hooks
import useAxios from "../../hooks/useAxios";

// style rules
import { Sizes } from "../../styles";

const App = ({ filtersJson }) => {
	const [filters] = useState(filtersJson ? JSON.parse(filtersJson) : []);
	// const [languages] = useState([
	// 	{ slug: "en", title: "English" },
	// 	{ slug: "fr", title: "French" },
	// ]);
	const [selectedSchool, setSelectedSchool] = useState(null);
	// const [selectedLanguage, setSelectedLanguage] = useState(null);

	const tickets = useAxios("tickets-schools");

	const ticket = tickets.find((ticket) => {
		// filtering first in situations where one ticket has multiple school boards
		const filteredSchoolBoard = ticket["school-boards"].filter(
			(school) => school.slug === selectedSchool
		);

		const slug = filteredSchoolBoard.length > 0 && filteredSchoolBoard[0].slug;
		// return slug === selectedSchool && ticket.language === selectedLanguage;
		return slug === selectedSchool;
	});

	return (
		<Wrapper>
			<TicketForm
				filters={filters}
				// languages={languages}
				selectedSchool={selectedSchool}
				setSelectedSchool={setSelectedSchool}
				// selectedLanguage={selectedLanguage}
				// setSelectedLanguage={setSelectedLanguage}
				ticket={ticket}
			/>
			<TicketDownload
				filters={filters}
				selectedSchool={selectedSchool}
				// selectedLanguage={selectedLanguage}
				tickets={tickets}
				ticket={ticket}
			/>
		</Wrapper>
	);
};

export default App;

App.propTypes = {
	filtersJson: PropTypes.any,
};

const Wrapper = styled.div`
	margin: 10rem 0;
	display: flex;
	flex-direction: column;
	gap: 4.6rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		display: flex;
		flex-direction: row;
		justify-content: center;
		gap: 13.3rem;
	}
`;
